import { getSelectedTableView, type TableQueryType } from 'owa-mail-list-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export default function isGroupSelected(): boolean {
    const selectedTable = getSelectedTableView();
    return (
        selectedTable &&
        (selectedTable.tableQuery.type == 2 ||
            (isGlobalFeatureEnabled('grp-loadFolders') && selectedTable.tableQuery.type == 3))
    );
}
